/**
 * Prototype UI — replace with Medplum hooks later.
 */

export type BillingTaskType =
  | 'missing-data'
  | 'unsigned-note'
  | 'submission-failed'
  | 'ack-rejected'
  | 'denial'
  | 'unmatched-era'
  | 'payment-failed';

export type BillingTaskPriority = 'high' | 'medium' | 'low';
export type BillingTaskStatus = 'open' | 'in-progress' | 'resolved';

export interface BillingTaskRow {
  id: string;
  type: BillingTaskType;
  priority: BillingTaskPriority;
  status: BillingTaskStatus;
  claimId?: string;
  clientName: string;
  summary: string;
  createdAt: string;
  assignee: string;
  linkTo?: string;
}

export const MOCK_BILLING_TASKS: BillingTaskRow[] = [];

export function findBillingTaskById(id: string | undefined): BillingTaskRow | undefined {
  if (!id) return undefined;
  return MOCK_BILLING_TASKS.find((r) => r.id === id);
}
